import { createWebHistory, createRouter, RouteRecordRaw } from "vue-router";
import HomePage from "../pages/HomePage.vue";
// import HomeThreePage from "../pages/HomeThreePage.vue";
// import AboutUsPage from "../pages/AboutUsPage.vue";
// import CustomerReviewsPage from "../pages/CustomerReviewsPage.vue";
// import OurChefsPage from "../pages/OurChefsPage.vue";
// import GalleryPage from "../pages/GalleryPage.vue";
// import FAQPage from "../pages/FAQPage.vue";
// import ReservationPage from "../pages/ReservationPage.vue";
// import BlogPage from "../pages/BlogPage.vue";
// import BlogLeftSidebarPage from "../pages/BlogLeftSidebarPage.vue";
// import BlogRightSidebarPage from "../pages/BlogRightSidebarPage.vue";
// import PostsByTagPage from "../pages/PostsByTagPage.vue";
// import PostsByCategoryPage from "../pages/PostsByCategoryPage.vue";
// import PostsByAuthorPage from "../pages/PostsByAuthorPage.vue";
// import BlogDetailsPage from "../pages/BlogDetailsPage.vue";
// import BlogDetailsLeftSidebarPage from "../pages/BlogDetailsLeftSidebarPage.vue";
// import BlogDetailsRightSidebarPage from "../pages/BlogDetailsRightSidebarPage.vue";
import TermsConditionsPage from "../pages/TermsConditionsPage.vue";
// import PrivacyPolicyPage from "../pages/PrivacyPolicyPage.vue";
import ErrorPage from "../pages/ErrorPage.vue";
// import MenuClassicPage from "../pages/MenuClassicPage.vue";
// import MenuGridPage from "../pages/MenuGridPage.vue";
// import MenuTabPage from "../pages/MenuTabPage.vue";
// import FoodDetailsPage from "../pages/FoodDetailsPage.vue";
// import FranchisePage from "../pages/FranchisePage.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "HomePage",
    component: HomePage,
  },
  // {
  //   path: "/home-three",
  //   name: "HomeThreePage",
  //   component: HomeThreePage,
  // },
  // {
  //   path: "/about",
  //   name: "AboutUsPage",
  //   component: AboutUsPage,
  // },
  // {
  //   path: "/reviews",
  //   name: "CustomerReviewsPage",
  //   component: CustomerReviewsPage,
  // },
  // {
  //   path: "/our-chef",
  //   name: "OurChefsPage",
  //   component: OurChefsPage,
  // },
  // {
  //   path: "/gallery",
  //   name: "GalleryPage",
  //   component: GalleryPage,
  // },
  // {
  //   path: "/franchise",
  //   name: "FranchisePage",
  //   component: FranchisePage,
  // },
  // {
  //   path: "/faq",
  //   name: "FAQPage",
  //   component: FAQPage,
  // },
  // {
  //   path: "/reservation",
  //   name: "ReservationPage",
  //   component: ReservationPage,
  // },
  // {
  //   path: "/blog",
  //   name: "BlogPage",
  //   component: BlogPage,
  // },
  // {
  //   path: "/blog-left-sidebar",
  //   name: "BlogLeftSidebarPage",
  //   component: BlogLeftSidebarPage,
  // },
  // {
  //   path: "/blog-right-sidebar",
  //   name: "BlogRightSidebarPage",
  //   component: BlogRightSidebarPage,
  // },
  // {
  //   path: "/tags",
  //   name: "PostsByTagPage",
  //   component: PostsByTagPage,
  // },
  // {
  //   path: "/categorys",
  //   name: "PostsByCategoryPage",
  //   component: PostsByCategoryPage,
  // },
  // {
  //   path: "/author",
  //   name: "PostsByAuthorPage",
  //   component: PostsByAuthorPage,
  // },
  // {
  //   path: "/blog-details",
  //   name: "BlogDetailsPage",
  //   component: BlogDetailsPage,
  // },
  // {
  //   path: "/blog-details-left-sidebar",
  //   name: "BlogDetailsLeftSidebarPage",
  //   component: BlogDetailsLeftSidebarPage,
  // },
  // {
  //   path: "/blog-details-right-sidebar",
  //   name: "BlogDetailsRightSidebarPage",
  //   component: BlogDetailsRightSidebarPage,
  // },
  {
    path: "/terms-conditions",
    name: "TermsConditionsPage",
    component: TermsConditionsPage,
  },
  // {
  //   path: "/privacy-policy",
  //   name: "PrivacyPolicyPage",
  //   component: PrivacyPolicyPage,
  // },
  { path: "/:pathMatch(.*)*", name: "ErrorPage", component: ErrorPage },
  // {
  //   path: "/menu-classic",
  //   name: "MenuClassicPage",
  //   component: MenuClassicPage,
  // },
  // {
  //   path: "/menu-grid",
  //   name: "MenuGridPage",
  //   component: MenuGridPage,
  // },
  // {
  //   path: "/menu-tab",
  //   name: "MenuTabPage",
  //   component: MenuTabPage,
  // },
  // {
  //   path: "/food-details",
  //   name: "FoodDetailsPage",
  //   component: FoodDetailsPage,
  // },
];

const router = createRouter({
  history: createWebHistory(),
  linkExactActiveClass: "active",
  routes,
  scrollBehavior() {
    return { top: 0, behavior: "smooth" };
  },
});

export default router;